// :cow: Cosmose CONFIDENTIAL :iso:
import { NgModule } from '@angular/core';
import { AuthService } from './shared/auth.service';
import { AuthRepository } from './shared/auth.repository';
import { LoginGuard } from './services/login.guard';
import { AuthRoutingModule } from '@med/app/auth/auth-routing.module';
import { CommonModule } from '@angular/common';
import { ContainerModule } from '@med/app/shared/modules/container/container.module';
import { LayoutModule } from '@med/app/shared/modules/layout/layout.module';
import { AuthComponent } from '@med/app/auth/auth.component';

@NgModule({
  declarations: [
    AuthComponent,
  ],
  imports: [
    CommonModule,
    AuthRoutingModule,
    ContainerModule,
    LayoutModule,
  ],
  providers: [
    AuthService,
    AuthRepository,
    LoginGuard,
  ],
})
export class AuthModule {
}
